@if (
  {
    mentionsSearchResults: mentionsSearchResults$ | async,
  };
  as data
) {
  <div class="mentions-menu-container">
    @if (data.mentionsSearchResults?.length && messageInput.isFocused) {
      <div class="mentions-menu" data-testid="mention-results">
        <app-participant-list
          [participantsList]="data.mentionsSearchResults"
          [userId]="userId"
          [selectable]="true"
          [preventFocus]="true"
          (newMentionClicked)="handleMention($event)"
        ></app-participant-list>
      </div>
    }
  </div>
  <app-message-input
    data-testid="message-composer"
    #messageInput
    [initialValue]="initialValue"
    [disableSubmit]="data.mentionsSearchResults !== null"
    [maxLength]="maxLength"
    (submitEvent)="handleSubmit($event)"
    (changeEvent)="handleChange($event)"
    (actionEvent)="handleAction($event)"
    (validationEvent)="handleValidationError($event)"
    (pasteEvent)="handlePaste($event)"
    (userInputEvent)="handleUserInput()"
  ></app-message-input>
}
